import { Flex, Spinner, useColorModeValue } from '@chakra-ui/react';


export default function Loader({ color, minH = "100vh"}) {
  const defaultColor = useColorModeValue('gray.50', 'gray.800');

  return (
    <Flex align="center" justify="center" minH={minH} bg={color || defaultColor}>
      <Spinner
        size="xl"
        thickness="4px"
        speed="0.7s"
        emptyColor={color}
        aria-label="Loading" // Accessibility improvement
      />
      {/* <Text ml={4} fontSize="lg" fontWeight="bold" color="gray.600">
        Loading...
      </Text> */}
    </Flex>
  );
}
